import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { RegisterHiveMutation, ViewHivesQuery } from '@/lib/gql/__generated__/canonical-documents';
import type {
  RegisterHiveInput,
  RegisterHiveMutationMutation,
  ViewHivesQueryQuery,
} from '@/lib/gql/__generated__/graphql';

export const viewHivesActor = fromPromise<ViewHivesQueryQuery, void>(async () => {
  const result = await apolloClient.query({ query: ViewHivesQuery, fetchPolicy: 'network-only' });
  if (!result.data) throw new Error('The registry did not return a hive list.');
  return result.data;
});

export type RegisterHiveOutput = { response: RegisterHiveMutationMutation; hiveId: string };

export const registerHiveActor = fromPromise<RegisterHiveOutput, Omit<RegisterHiveInput, 'hiveId'>>(
  async ({ input }) => {
    const hiveId = crypto.randomUUID();
    const result = await apolloClient.mutate({
      mutation: RegisterHiveMutation,
      variables: {
        input: {
          hiveId,
          apiaryName: input.apiaryName,
          hiveNumber: input.hiveNumber,
          queenYear: input.queenYear,
          colonyStrain: input.colonyStrain,
        },
      },
    });
    if (!result.data) throw new Error('The registry did not return a response.');
    return { response: result.data, hiveId };
  },
);
